import { useState, useEffect } from "react";
import ProductCard from "../components/ProductCard";
import { useSearchParams } from "react-router-dom";
import Fuse from "fuse.js";

import "../styles/catalogo.css";

function Catalogo() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);

  const [busca, setBusca] = useState("");

  const categoriaUrl = searchParams.get("categoria") || "todos";
  const [categoriaAtiva, setCategoriaAtiva] = useState(categoriaUrl);

  const [itensVisiveis, setItensVisiveis] = useState(8);

  function slugCategoria(texto) {
    return texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }

  const categorias = [
    { nome: "Todos", slug: "todos" },
    ...Array.from(
      new Map(
        produtos.map((p) => [slugCategoria(p.categoria), p.categoria]),
      ).entries(),
    )
      .map(([slug, nome]) => ({
        slug,
        nome,
      }))
      .sort((a, b) => a.nome.localeCompare(b.nome)),
  ];

  /* ===============================
     CARREGAR CATÁLOGO DO GIT
  =============================== */

  useEffect(() => {
    async function carregarCatalogo() {
      try {
        const cache = localStorage.getItem("catalogo_accium");

        if (cache) {
          const produtosCache = JSON.parse(cache);
          setProdutos(produtosCache);
          setLoading(false);
        }

        const response = await fetch(
          "https://raw.githubusercontent.com/accium-hub/accium-catalogo/main/catalogo/produtos.json",
          { cache: "no-store" },
        );

        const data = await response.json();

        const produtosValidos = data.filter(
          (p) => p && p.nome && p.categoria && p.imagem && p.nome.trim() !== "",
        );

        setProdutos(produtosValidos);

        localStorage.setItem(
          "catalogo_accium",
          JSON.stringify(produtosValidos),
        );
      } catch (erro) {
        console.error("Erro ao carregar catálogo:", erro);
      } finally {
        setLoading(false);
      }
    }

    carregarCatalogo();
  }, []);

  /* ===============================
     BUSCA INTELIGENTE
  =============================== */

  const fuse = new Fuse(produtos, {
    keys: ["nome", "descricao"],
    threshold: 0.4,
  });

  let resultadosBusca = produtos;

  if (busca.trim() !== "") {
    resultadosBusca = fuse.search(busca).map((r) => r.item);
  }

  /* ===============================
     FILTRO POR CATEGORIA
  =============================== */

  const produtosFiltrados = resultadosBusca.filter((produto) => {
    if (categoriaAtiva === "todos") return true;

    const categoriaProduto = slugCategoria(produto.categoria);

    return categoriaProduto === categoriaAtiva;
  });

  /* ===============================
     PAGINAÇÃO (LOAD MORE)
  =============================== */

  const produtosVisiveis = produtosFiltrados.slice(0, itensVisiveis);

  const carregarMais = () => {
    setItensVisiveis(itensVisiveis + 8);
  };

  /* ===============================
     LOADING
  =============================== */

  if (loading) {
    return (
      <section className="catalogo-section">
        <h1 className="catalogo-title">Catálogo de Produtos</h1>

        <div className="produtos-grid">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="product-card skeleton-card"></div>
          ))}
        </div>
      </section>
    );
  }

  /* ===============================
     RENDER
  =============================== */

  return (
    <section className="catalogo-section">
      <h1 className="catalogo-title">Catálogo de Produtos</h1>

      {/* BUSCA */}

      <input
        type="text"
        placeholder="Buscar produto..."
        className="catalog-search"
        value={busca}
        onChange={(e) => setBusca(e.target.value)}
      />

      <div className="catalog-layout">
        {/* SIDEBAR */}

        <div className="catalog-sidebar">
          {categorias.map((cat) => (
            <button
              key={cat.slug}
              className={`categoria-btn ${
                categoriaAtiva === cat.slug ? "active" : ""
              }`}
              onClick={() => {
                setCategoriaAtiva(cat.slug);

                setSearchParams({
                  categoria: cat.slug,
                });

                setItensVisiveis(8);
              }}
            >
              {cat.nome}
            </button>
          ))}
        </div>

        {/* PRODUTOS */}

        <div className="catalog-products">
          <div className="produtos-grid">
            {produtosVisiveis.map((produto) => (
              <ProductCard key={produto.id} produto={produto} />
            ))}
          </div>

          {/* BOTÃO LOAD MORE */}

          {itensVisiveis < produtosFiltrados.length && (
            <button className="load-more" onClick={carregarMais}>
              Carregar mais produtos
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export default Catalogo;
